var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicComponent,{tag:"component",staticClass:"eui-a-heading",class:[`-h${_vm.level}`, {'-bold': _vm.bold === true}]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }